export function generarPdf (pdfBase64) {
  const byteCharacters = atob(pdfBase64)
  const byteNumbers = []
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers.push(byteCharacters.charCodeAt(i))
  }
  const file = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' })

  return URL.createObjectURL(file)
}

export function abrirPestanaEnBlanco () {
  const loadingUrl = '/static/baseDescargaFichero.html'
  const nuevaPestana = window.open(loadingUrl, '_blank')
  if (!nuevaPestana) {
    return null
  }

  return nuevaPestana
}

export function abrirPdfEnPestanaPreabierta (pdfUrl, targetWindow) {
  // Si se ha preabierto una pestana y el usuario la cierra, se cancela la apertura del PDF.
  if (targetWindow) {
    if (!targetWindow.closed) {
      targetWindow.location.href = pdfUrl
    }
    return
  }

  const link = document.createElement('a')
  link.href = pdfUrl
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  link.style.display = 'none'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function cerrarPestana (targetWindow) {
  if (targetWindow && !targetWindow.closed) {
    targetWindow.close()
  }
}

function tieneCodigoError (codigo) {
  return codigo !== undefined && codigo !== null && codigo !== '' && Number(codigo) !== 0
}

function textoPlano (valor) {
  if (!valor) {
    return ''
  }
  if (typeof valor === 'object') {
    return valor.message || ''
  }
  return String(valor)
}

/**
 * Compone el mensaje de error a partir de una respuesta del WS o de un error de axios
 * (los servicios devuelven el error de axios resuelto, con los datos en error.response.data).
 */
export function mensajeErrorWs (respuesta) {
  if (!respuesta) {
    return ''
  }
  if (typeof respuesta === 'string') {
    return respuesta
  }
  const datos = respuesta.data || (respuesta.response && respuesta.response.data) || null
  if (datos && typeof datos === 'object') {
    const origen = (datos.dataRes && (datos.dataRes.errorMsg || datos.dataRes.errorCode)) ? datos.dataRes : datos
    // Un errorCode informado y distinto de 0 prevalece sobre statusCode/statusText,
    // que el WS puede devolver como "200"/"ok" aunque la peticion no haya devuelto datos
    if (tieneCodigoError(origen.errorCode)) {
      const textoError = textoPlano(origen.errorMsg) || textoPlano(origen.statusText)
      return textoError + '  (' + origen.errorCode + ')'
    }
    const texto = textoPlano(origen.statusText) || textoPlano(origen.errorMsg) || textoPlano(origen.exception) || textoPlano(origen.message)
    const codigo = origen.statusCode || (respuesta.response && respuesta.response.status) || respuesta.status || ''
    // Respuesta correcta sin documento: no hay mensaje de error que mostrar
    if (String(codigo) === '200' && (texto === '' || texto.toLowerCase() === 'ok')) {
      return ''
    }
    if (texto !== '' || codigo !== '') {
      return texto + (codigo !== '' ? '  (' + codigo + ')' : '')
    }
  }
  if (respuesta.response && respuesta.response.status) {
    return respuesta.response.statusText + '  (' + respuesta.response.status + ')'
  }
  return respuesta.message || ''
}

/**
 * Lanza en paralelo varias descargas de PDF que comparten una unica pestana preabierta.
 * Los navegadores solo permiten abrir una ventana emergente por pulsacion, por lo que
 * todos los documentos se muestran en esa pestana:
 *  - 0 documentos: se cierra la pestana.
 *  - 1 documento: la pestana navega al PDF.
 *  - Varios: la pestana muestra un visor con un boton por documento.
 * Cada peticion es { nombre, obtener }, donde obtener() devuelve una promesa resuelta con
 * el base64 del PDF o rechazada con el error. El titulo se usa como titulo de la pestana
 * del visor (ej. Albaranes, Facturas). Devuelve la lista de mensajes de error.
 */
export function descargarPdfsEnPestana (peticiones, ventanaPdf, titulo) {
  const documentos = []
  const errores = []
  return Promise.all(peticiones.map((peticion, indice) =>
    Promise.resolve()
      .then(peticion.obtener)
      .then(report => {
        documentos.push({ orden: indice, nombre: peticion.nombre, url: generarPdf(report) })
      })
      .catch(error => {
        console.error(error)
        errores.push(mensajeErrorWs(error))
      })
  )).then(() => {
    documentos.sort((a, b) => a.orden - b.orden)
    if (documentos.length === 0) {
      cerrarPestana(ventanaPdf)
    } else if (documentos.length === 1) {
      abrirPdfEnPestanaPreabierta(documentos[0].url, ventanaPdf)
    } else {
      mostrarVisorDocumentos(documentos, ventanaPdf, titulo)
    }
    return errores
  })
}

/**
 * Espera a que la pestana preabierta haya cargado la plantilla de espera
 * (mismo origen) antes de manipular su documento.
 */
function esperarPestanaCargada (targetWindow, intentosRestantes) {
  return new Promise(resolve => {
    const comprobar = restantes => {
      let lista = false
      try {
        lista = targetWindow.document.readyState === 'complete' &&
          targetWindow.location.pathname.indexOf('baseDescargaFichero') !== -1
      } catch (e) {
        lista = false
      }
      if (lista || restantes <= 0) {
        resolve(lista)
      } else {
        setTimeout(() => comprobar(restantes - 1), 100)
      }
    }
    comprobar(intentosRestantes)
  })
}

function mostrarVisorDocumentos (documentos, targetWindow, titulo) {
  if (!targetWindow || targetWindow.closed) {
    // Sin pestana preabierta (bloqueada o cerrada por el usuario): solo se puede intentar abrir el primero
    abrirPdfEnPestanaPreabierta(documentos[0].url, null)
    return
  }
  esperarPestanaCargada(targetWindow, 50).then(cargada => {
    if (targetWindow.closed) {
      return
    }
    if (!cargada) {
      targetWindow.location.href = documentos[0].url
      return
    }
    construirVisor(targetWindow.document, documentos, titulo)
  })
}

const ICONO_DOCUMENTO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z"/></svg>'
const ICONO_ABRIR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"/></svg>'

/**
 * Obtiene el color principal y la tipografia de la marca a partir de un boton
 * .datPrimaryBtnOut de la aplicacion, para que el visor use el mismo estilo.
 */
function obtenerEstiloMarca () {
  const estilo = { color: '#1976d2', fuente: 'Arial, sans-serif' }
  try {
    const referencia = document.querySelector('.datPrimaryBtnOut')
    if (referencia) {
      const calculado = window.getComputedStyle(referencia)
      if (calculado.borderTopColor && calculado.borderTopColor !== 'rgba(0, 0, 0, 0)') {
        estilo.color = calculado.borderTopColor
      }
      if (calculado.fontFamily) {
        estilo.fuente = calculado.fontFamily
      }
    }
  } catch (e) {
    console.error(e)
  }
  return estilo
}

function construirVisor (doc, documentos, titulo) {
  const marca = obtenerEstiloMarca()
  doc.title = titulo || 'Documentos'

  const css = doc.createElement('style')
  css.textContent =
    'html, body { height: 100%; margin: 0; }' +
    'body { display: flex; flex-direction: column; background: #f7f7f7; font-family: ' + marca.fuente + '; }' +
    '.visor-barra { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; padding: 10px 16px;' +
    ' background: #ffffff; border-bottom: 1px solid #e0e0e0; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08); }' +
    '.visor-btn { display: inline-flex; align-items: center; gap: 6px; height: 28px; padding: 0 12px;' +
    ' border: 1px solid ' + marca.color + '; border-radius: 2px; background: transparent; color: ' + marca.color + ';' +
    ' font: 500 13px ' + marca.fuente + '; text-decoration: none; cursor: pointer; transition: background-color 0.15s, color 0.15s; }' +
    '.visor-btn:hover, .visor-btn.activo { background: ' + marca.color + '; color: #ffffff; }' +
    '.visor-btn svg { width: 16px; height: 16px; fill: currentColor; }' +
    '.visor-abrir { margin-left: auto; }' +
    '.visor-pdf { flex: 1; width: 100%; border: 0; }'
  doc.head.appendChild(css)

  doc.body.innerHTML = ''
  doc.body.removeAttribute('style')

  const barra = doc.createElement('div')
  barra.className = 'visor-barra'

  const visor = doc.createElement('iframe')
  visor.className = 'visor-pdf'
  visor.title = 'Documento'

  const botones = documentos.map((documento, indice) => {
    const boton = doc.createElement('button')
    boton.type = 'button'
    boton.className = 'visor-btn'
    boton.innerHTML = ICONO_DOCUMENTO
    boton.appendChild(doc.createTextNode(documento.nombre || ('Documento ' + (indice + 1))))
    boton.addEventListener('click', () => seleccionar(indice))
    barra.appendChild(boton)
    return boton
  })

  const enlaceAbrir = doc.createElement('a')
  enlaceAbrir.className = 'visor-btn visor-abrir'
  enlaceAbrir.target = '_blank'
  enlaceAbrir.rel = 'noopener'
  enlaceAbrir.innerHTML = ICONO_ABRIR
  enlaceAbrir.appendChild(doc.createTextNode('Abrir en pestaña nueva'))
  barra.appendChild(enlaceAbrir)

  function seleccionar (indice) {
    visor.src = documentos[indice].url
    enlaceAbrir.href = documentos[indice].url
    botones.forEach((boton, i) => {
      boton.classList.toggle('activo', i === indice)
    })
  }

  doc.body.appendChild(barra)
  doc.body.appendChild(visor)
  seleccionar(0)
}

export function downloadZip (filename, data) {
  var element = document.createElement('a')
  element.setAttribute('href', 'data:application/zip;base64,' + data)
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}



// WEBPACK FOOTER //
// ./src/utils/utilDescargarPdf.js